import { Logger, Zero, Components, Utils } from 'Zero';
import { detect } from 'detect-browser';
const Log = new Logger('Panel');

export default class ZPanel extends Components {
  constructor(element) {
    super(element);
    this.Opened = false;
    this.trigger = this.element.find('.js-sl_panel-trigger');
    this.target = this.element.find('.js-sl_panel-target');
    let timing = this.element.data('animate-time');
    if (timing) {
      this.animateTime = this.element.data('animate-time');
    } else {
      this.animateTime = 370;
    }
    this.trigger.on('click.panel', () => {
      this.togglePanel();
    });

    $(document).on('click', (e) => {
      this.closeSerivesPanel(e);
    });
  }

  get Messages() {
    return {
      'Storelocator:Filters:Applied': this.closeSerivesPanel,
    };
  }

  closeSerivesPanel(e) {
    const panel = $('.is-open').find('.mr_sl-panel-target');

    if ($(e.target).closest(".is-open").length === 0) {
      $('.services-panel').removeClass('is-open');
      this.Opened = false;
      panel.stop().animate({ height: '0', 'min-height': '0' }, 350);
      $('body').removeClass('panel-is-opened');
    }
  }

  autoAnimate(elem, time) {
    let curHeight = elem.height();
    let autoHeight = elem.css('height', 'auto').height();
    elem.height(curHeight);
    elem.stop().animate({ height: autoHeight }, time, function() {
      elem.css({ height: 'auto', 'min-height': 'auto' });
    });
  }

  togglePanel() {
    if (this.Opened) {
      if (this.element[0].dataset.attachbodyclass) {
        $('body').removeClass('panel-is-opened');
      }
      this.closePanel();
    } else {
      if (this.element[0].dataset.attachbodyclass) {
        $('body').addClass('panel-is-opened');
      }
      this.openPanel();
    }
  }
  openPanel() {
    let animateTime = this.animateTime;
    this.element.addClass('is-open');
    this.autoAnimate(this.target, animateTime);
    this.Opened = true;
  }
  closePanel() {
    $('body').removeClass('panel-is-opened');
    let animateTime = this.animateTime;
    this.element.removeClass('is-open');
    this.Opened = false;
    this.target.stop().animate({ height: '0', 'min-height': '0' }, animateTime);
  }
}

export { ZPanel };
